import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { CyTestDirective } from '@portal/directive';
import { GetAddressButtonComponent } from '../component';
import { PortalFieldTypeConfig } from '@portal/form/data-access';

@Component({
  selector: 'portal-form-single-button',
  standalone: true,
  imports: [FormlyModule, CyTestDirective, NgSwitch, NgSwitchDefault, NgSwitchCase, GetAddressButtonComponent],
  template: `
    <ng-container [ngSwitch]="props.type">
      <portal-form-get-address-button
        *ngSwitchCase="'get-address'"
        [disabled]="disabled"
        (emitter)="props.click?.(field, $event)"
      >
        {{ props.label }}
      </portal-form-get-address-button>

      <button
        class="field-single-button"
        *ngSwitchDefault
        [type]="props.type"
        [disabled]="disabled"
        (click)="props.click?.(field, $event)"
        [portalCyTest]="props.cyTest"
      >
        {{ props.label }}
      </button>
    </ng-container>
  `,
  styles: [':host {display: block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleButtonComponent extends FieldType<PortalFieldTypeConfig> {
  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'single-button',
          component: SingleButtonComponent,
          wrappers: ['form-field'],
          defaultOptions: { props: { hideLabel: true, type: 'button' } },
        },
      ],
    }),
  ],
})
export class FormSingleButtonModule {}
